.composer-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
